export default __webpack_public_path__ + "static/media/witcoin_poster.8f8b7a13.jpg";